import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LeadProvider } from "@/components/LeadDialog";
import NavigatorPage from "@/pages/NavigatorPage";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <LeadProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<NavigatorPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
      </LeadProvider>
    </div>
  );
}

export default App;
